import joi from 'joi';
import { makeDefinitionFor } from '../../../helpers/endpoint.definition.details.generator';
import { generateValidationError, success } from '../../../shared/api.response.def';
import { form } from '../../../shared/form.def';

const response = joi.object({
	results: joi.array().items(form),
});

export const definition = makeDefinitionFor(
	'/form.json',
	{
		description: 'Get a list of forms within a department',
		method: 'get',
		summary: 'Form list',
		tags: ['Form'],
		params: [
			{
				$ref: '#/components/parameters/ikeDepartmentId',
			},
		],
	},
	[
		{
			code: 200,
			description: success,
			schema: response,
		},
		generateValidationError(),
	]
);
